import { getRandomBase64Code } from "./getRandomBase64Code";

export function generateNonce(): string {
    return getRandomBase64Code(24);
}
